export default "__VITE_ASSET__c408e013__"